(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  function initHeader() {
    const toggle = $('[data-menu-toggle]');
    const menu = $('[data-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((clock) => {
      const target = new Date(clock.dataset.countdown).getTime();
      if (!Number.isFinite(target)) return;
      const fields = {
        days: $('[data-days]', clock), hours: $('[data-hours]', clock),
        minutes: $('[data-minutes]', clock), seconds: $('[data-seconds]', clock)
      };
      const tick = () => {
        const remaining = Math.max(0, target - Date.now());
        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor((remaining / 3600000) % 24),
          minutes: Math.floor((remaining / 60000) % 60),
          seconds: Math.floor((remaining / 1000) % 60)
        };
        Object.entries(values).forEach(([key, value]) => { if (fields[key]) fields[key].textContent = String(value).padStart(2, '0'); });
      };
      tick();
      const timer = setInterval(tick, 1000);
      window.addEventListener('pagehide', () => clearInterval(timer), { once: true });
    });
  }

  function initReveal(root = document) {
    const items = $$('[data-reveal]', root);
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-revealed'));
      return;
    }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); }
    }), { threshold: .12, rootMargin: '0px 0px -5% 0px' });
    items.forEach((item) => observer.observe(item));
  }

  function initCarousels(root = document) {
    $$('[data-carousel]', root).forEach((carousel) => {
      const track = $('[data-carousel-track]', carousel);
      if (!track) return;
      const move = (direction) => track.scrollBy({ left: direction * Math.min(track.clientWidth * .82, 720), behavior: 'smooth' });
      $('[data-carousel-prev]', carousel)?.addEventListener('click', () => move(-1));
      $('[data-carousel-next]', carousel)?.addEventListener('click', () => move(1));
    });
  }

  function formatCartMoney(cents) {
    const currency = document.body.dataset.currency || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (error) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; }
  }

  function showCartNote(item) {
    const note = $('[data-cart-note]');
    if (!note) return;
    const title = $('[data-cart-note-title]', note);
    const variant = $('[data-cart-note-variant]', note);
    const price = $('[data-cart-note-price]', note);
    const entry = $('[data-cart-note-entry]', note);
    const image = $('[data-cart-note-image]', note);
    const imageWrap = $('[data-cart-note-image-wrap]', note);
    const imageUrl = item?.featured_image?.url || item?.image || '';
    if (title) title.textContent = item?.product_title || item?.title || 'Added to your cart.';
    if (variant) variant.textContent = item?.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    if (price) price.textContent = formatCartMoney(item?.final_price ?? item?.price);
    if (entry) {
      const amount = item?.properties?._entry_amount;
      entry.textContent = amount ? `${amount} ENTRIES` : '';
    }
    if (image && imageWrap && imageUrl) {
      image.src = imageUrl;
      image.alt = item?.product_title || item?.title || 'Added product';
      imageWrap.hidden = false;
    } else if (imageWrap) imageWrap.hidden = true;
    note.classList.add('is-visible');
    clearTimeout(note.hideTimer);
    note.hideTimer = setTimeout(() => note.classList.remove('is-visible'), 4400);
  }

  function initAjaxCart(root = document) {
    $$('form[data-ajax-cart]', root).forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = $('button[type="submit"]', form);
        if (button) button.disabled = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Cart request failed');
          const item = await response.json();
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
          $$('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
          showCartNote(item);
        } catch (error) { form.submit(); } finally { if (button) button.disabled = false; }
      });
    });
  }

  function initVariantButtons(root = document) {
    $$('[data-variant-form]', root).forEach((form) => {
      if (form.dataset.variantReady) return;
      form.dataset.variantReady = 'true';
      const price = $('[data-product-price]');
      const entry = $('[data-variant-entry]', form);
      const entryInput = $('[data-variant-entry-input]', form);
      const selectedVariant = $('[data-selected-variant]', form);
      const submit = $('[data-product-submit]', form);
      const data = $('[data-variant-data]', form);
      if (!data || !selectedVariant) return;
      let variants;
      try { variants = JSON.parse(data.textContent); } catch (_) { return; }
      const groups = $$('[data-option-position]', form);
      const update = (changedRadio) => {
        const choices = groups.map((group) => $('.variant-radio:checked', group)?.value);
        let variant = variants.find((item) => item.options.every((value, index) => value === choices[index]));
        if (!variant && changedRadio) {
          const position = Number(changedRadio.name.replace('option-', '')) - 1;
          variant = variants.find((item) => item.available && item.options[position] === changedRadio.value)
            || variants.find((item) => item.options[position] === changedRadio.value);
          if (variant) groups.forEach((group, index) => {
            const next = $$('input.variant-radio', group).find((radio) => radio.value === variant.options[index]);
            if (next) next.checked = true;
          });
        }
        if (submit) {
          submit.disabled = !variant?.available;
          submit.textContent = variant ? (variant.available ? 'ADD TO CART' : 'SOLD OUT') : 'UNAVAILABLE';
        }
        if (!variant) return;
        selectedVariant.value = variant.id;
        if (price) price.textContent = variant.price;
        if (entry) entry.textContent = `${variant.entries} ENTRIES`;
        if (entryInput) entryInput.value = variant.entries;
        if (groups.length) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };
      $$('input.variant-radio', form).forEach((radio) => radio.addEventListener('change', () => update(radio)));
    });
  }

  function initCartEntryTally(root = document) {
    const form = $('[data-cart-form]', root);
    if (!form || form.dataset.entryTallyReady) return;
    form.dataset.entryTallyReady = 'true';
    const total = $('[data-cart-entry-total]', form);
    const quantities = $$('[data-cart-entry-quantity]', form);
    const update = () => {
      let entryTotal = 0;
      quantities.forEach((input) => {
        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        const entryAmount = Math.max(0, Number.parseInt(input.dataset.entryEach, 10) || 0);
        entryTotal += quantity * entryAmount;
        const rowTotal = input.closest('.cart-row')?.querySelector('[data-line-entry-total]');
        if (rowTotal) rowTotal.textContent = String(quantity * entryAmount);
      });
      if (total) total.textContent = entryTotal.toLocaleString();
    };
    quantities.forEach((input) => input.addEventListener('input', update));
    update();
  }

  function boot(root = document) { initCountdowns(root); initReveal(root); initCarousels(root); initAjaxCart(root); initVariantButtons(root); initCartEntryTally(root); }
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    boot();
    $('[data-cart-note-close]')?.addEventListener('click', () => $('[data-cart-note]')?.classList.remove('is-visible'));
  });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
